import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { fetchAccounts } from '../../actions/members';
import viewHelper from '../../helpers/view';
import CacheService from '../../services/cacheService';
import Spinner from '../shared/spinner';
import NoRecordFound from '../shared/noRecordFound';
import MemberInfo from '../shared/memberInfo';

class Accounts extends Component {

    componentDidMount() {
        this.props.fetchAccounts();
    }

    renderAccounts() {
        let accounts = viewHelper.getSortedAccounts(this.props.accounts);
        if(accounts.length > 0) {
            return _.map(accounts, (account) => {
                return (
                    <div className="media item" key={account.id}>
                        <div className="media-body">
                            <h4 className="media-heading">
                                <Link to={`/${CacheService.getToken().bname}/accounts/${account.id}`}>
                                    {account.id} - {account.account_name} - {account.payment_method}
                                    <span className={`badge ${viewHelper.accountHasActiveStatus(account.account_active) ? 'badge-success' : 'badge-danger'}`}>
                                    {viewHelper.accountHasActiveStatus(account.account_active) ? 'Active' : 'Inactive'}
                                </span>
                                </Link>
                            </h4>
                            <div className="column">
                                <span className="label-heading">Entered On:</span>
                                <span className="label-text">{viewHelper.getFormattedDate(account.entered_on)}</span>
                            </div>
                            <div className="column">
                                <span className="label-heading">Name On Account:</span>
                                <span className="label-text">{account.name_on_account}</span>
                            </div>
                            <div className="column">
                                <span className="label-heading">Bank Name:</span>
                                <span className="label-text">{account.bank_name}</span>
                            </div>
                            <div className="column">
                                <span className="label-heading">ABA #:</span>
                                <span className="label-text">{account.aba_no}</span>
                            </div>
                            <div className="column">
                                <span className="label-heading">Description:</span>
                                <span className="label-text">{account.description}</span>
                            </div>
                        </div>
                    </div>
                )
            });
        } else {
            return <NoRecordFound />
        }
    }

    render () {
        const { member, accounts } = this.props;
        if(!accounts) {
            return (
                <div className="container content">
                    <Spinner />
                </div>
            );
        } else {
            return (
                <div className="container content">
                    <MemberInfo title={`${viewHelper.getFullName(member)} - Accounts`} />
                    <div className="col-xs-12 col-md-12 col-lg-12 no-padding">
                        <div className="row-eq-height">
                            <div className="col-xs-12 col-md-12 col-lg-12 no-padding border-bottom">
                                <ul className="detail-list">
                                    {this.renderAccounts()}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    const { accounts } = state;
    return {
        accounts
    };
}

export default connect(mapStateToProps, { fetchAccounts })(Accounts);